import $ from 'jquery';
import api from './data/_my-account';


(() => {
    const el = {
        target: '.js-forget_password_action',
        input: '#user_login'
    }

    const handle_forget_password = () => {
        $(document).on('submit', el.target, (event) => {
            event.preventDefault();

            const $parent   = $(event.target);
            const $input    = $parent.find(el.input);

            const email     = $input.val();

            api.forget_password(email)
            .done((res) => {
                if(res.redirect_to) {
                    location.href = res.redirect_to;
                }
            })
            .catch((xhr) => {
                const response = xhr.responseJSON;

                $.each(response.fragments, (key, element) => {
                    $(key).html(element);
                })
            });
        });
    }

    try {
        handle_forget_password();
    } catch (Error) {
        // eslint-disable-next-line no-console
        console.log('Error: ', Error);
    }
})();